"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var _styledTools = require("styled-tools");

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas-lab/typography");

var Root = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  flex: 1;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom-style: solid;\n  border-bottom-width: ", ";\n  border-bottom-color: ", ";\n"])), (0, _styledTools.theme)('colorNeutralWhite'), (0, _styledTools.ifProp)('isActive', '2px', '1px'), (0, _styledTools.ifProp)('isActive', (0, _styledTools.theme)('colorBrandPrimaryDefault'), (0, _styledTools.theme)('colorNeutral10')));

exports.Root = Root;
Root.Label = (0, _stylitas.styled)(_typography.Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));